module.exports = __webpack_public_path__ + "static/img/productPartner_1_1.c7d3dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_1_1.png
// module id = VFPP
// module chunks = 34